import notificationStore from '../NotificationStore';
import { NotificationProps } from '../state/NotificationState';
import { ActionType } from '.';
import { getId } from './../../utils/MiscUtils';

export class NotificationActions {
  static addNotification(props: NotificationProps) {
    let notification = { ...props };
    if (!notification.id) {
      notification.id = getId();
    }
    notificationStore.dispatch({ type: ActionType.ADD_NOTIFICATION, data: notification });
  }

  static removeNotification(notification: NotificationProps) {
    notificationStore.dispatch({ type: ActionType.REMOVE_NOTIFICATION, data: notification });
  }
}
